export function currencyFormatter(locale, currency, fractionDigits = 2) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: fractionDigits,
  })
}

export function decimalFormatter(locale, fractionDigits = 2) {
  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: fractionDigits,
  })
}

export function percentFormatter(locale, fractionDigits = 0) {
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: fractionDigits,
  })
}

export function currencySymbol(locale, currency) {
  return currencyFormatter(locale, currency)
    .formatToParts()
    .find(part => part.type === 'currency').value
}